import './LanguageSelection.css'

import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MaterialSymbol } from 'react-material-symbols'

import LanguageDetector from 'i18next-browser-languagedetector'
import { Button } from 'primereact/button'
import { ListBox, ListBoxChangeEvent } from 'primereact/listbox'
import { OverlayPanel } from 'primereact/overlaypanel'
import { useLocalstorageState } from 'rooks'

import { Constants } from '../../../../../utils/constants'
import { SupportedLanguage } from '../../../../../utils/i18n'

interface Language {
  name: string
  code: SupportedLanguage
}

export const LanguageSelection: React.FC = () => {
  const panelRef = useRef<OverlayPanel | null>(null)

  const { i18n } = useTranslation()
  const detectedLanguage = i18n.use(LanguageDetector).language
  const [language, setLanguage] = useLocalstorageState(
    Constants.LOCAL_STORAGE_LANGUAGE_KEY,
    detectedLanguage,
  )
  const languages: Language[] = [
    { name: 'Deutsch', code: 'de' },
    { name: 'English', code: 'en' },
  ]

  const [selectedLanguage, setSelectedLanguage] = useState<Language | null>(
    language ? languages.find(lang => lang.code === language) || null : null,
  )

  useEffect(() => {
    if (language) {
      const foundLanguage = languages.find(lang => lang.code === language)
      if (foundLanguage) {
        setSelectedLanguage(foundLanguage)
      }
    }
  }, [])

  const handleLanguageChange = (selected: Language | null) => {
    if (selected) {
      setLanguage(selected.code)
      i18n.changeLanguage(selected.code)
      setSelectedLanguage(selected)
      panelRef.current?.hide()
    }
  }

  const languageTemplate = (option: Language) => (
    <div className="flex align-items-center px-2">
      <div className="mr-5">{option.name}</div>
      {option.code === selectedLanguage?.code && (
        <div className="ml-auto">
          <i className="pi pi-check"></i>
        </div>
      )}
    </div>
  )

  return (
    <>
      <Button
        link
        aria-label="Language selection"
        onClick={e => panelRef.current?.toggle(e, undefined)}
        icon={<MaterialSymbol icon="language" size={24} />}
        className="header__language-selection__text-color p-2 border-none"
      >
        <span className="hidden md:inline ml-2">
          {selectedLanguage?.code.toLocaleUpperCase()}
        </span>
      </Button>

      <OverlayPanel ref={panelRef} pt={{ content: { className: 'p-0' } }}>
        <ListBox
          value={selectedLanguage}
          onChange={(e: ListBoxChangeEvent) => handleLanguageChange(e.value)}
          options={languages}
          optionLabel="name"
          itemTemplate={languageTemplate}
          className="w-full md:w-14rem border-none"
          listStyle={{ maxHeight: '250px' }}
        />
      </OverlayPanel>
    </>
  )
}
